import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import KandidatenList from '~/scripts/KandidatenList';
import Icon from '~/core/scripts/components/Icon';
import { numberFormat } from '~/core/scripts/utils';
import { getPartyName } from '../config';

class RankingList extends PureComponent {
  static propTypes = {
    onClickItem: PropTypes.func,
    isClickable: PropTypes.bool,
    showVotes: PropTypes.bool
  }

  static defaultProps = {
    onClickItem: () => {},
    isClickable: false,
    showVotes: false
  }

  format(num, suffix = false) {
    if (isNaN(num)) {
      return '-';
    }

    const formattedNumber = numberFormat(num, 1);

    return suffix ? `${formattedNumber} ${suffix}` : formattedNumber;
  }

  renderListItem(item, index) {
    const isActive = item.name === this.props.selectedParty;
    if(item.reps != null) {
      let reps = item.reps;
      let names = reps.names;
      let results = reps.results;
      let sortedResults = results.slice(0).sort(function(a, b){return b-a});
      let sortedNames = [];
      for (let i=0; i<sortedResults.length; i++) {
        sortedNames.push(names[results.indexOf(sortedResults[i])]);
        let removeAt = results.indexOf(sortedResults[i]);
        results.splice(removeAt, 1);
        names.splice(removeAt, 1);
      }
      item.reps.names = sortedNames;
      item.reps.results = sortedResults;
    }
    const itemClasses = classnames(
      'rankinglist__item',
      { 'is-active': isActive, 'is-clickable': this.props.isClickable }
    );

    return (
      <Fragment key={`rankinglist__item-${item.name}`}>
        <tr
          className={itemClasses}
          onClick={() => this.props.onClickItem(item.name)}
        >
          <td className="rankinglist__item-index">
            {index + 1}.
          </td>
          <td className="rankinglist__item-name">
            {getPartyName(item.name)}
          </td>
          {this.props.showVotes && (
            <td className="rankinglist__item-votes">
              {item.value}
            </td>
          )}
          <td className="rankinglist__item-value">
            {this.format(item.valueRel, '%')}
            {(isActive) && (
              <div
                className="rankinglist__item-close"
                onClick={(evt) => {
                  evt.stopPropagation();
                  this.props.onClickItem(item.name);
                }}
              >
                <Icon type="close" />
              </div>
            )}
          </td>
        </tr>
        {item.reps && <KandidatenList data={item.reps} />}
      </Fragment>
    )
  }
  render() {
    return (
      <table className="rankinglist">
        <thead>
          <tr>
            <th colSpan="2" className="rankinglist__thead-party">Parteistimmen</th>
            {this.props.showVotes && <th className="rankinglist__thead-votes">Stimmen</th>}
            <th className="rankinglist__thead-value">Ergebnis</th>
          </tr>
        </thead>
        <tbody>
          {this.props.data.map((d, i) => this.renderListItem(d, i))}
        </tbody>
      </table>
    );
  }
}

export default RankingList;
